const TRANSLATIONS_FR = {
  'application.title': 'SAILOR File Injection Tool',
  'header.roles': 'Roles:',
  'header.log.out': 'Déconnexion',

  'breadcrumb.home': 'Accueil',
  'breadcrumb.import': 'File-set ',
  'breadcrumb.file': 'Fichier ',

  'button.save': 'Sauver',
  'button.cancel': 'Annuler',
  'button.ok': 'OK',
  'add_comment': 'Ajouter un commentaire',

  'upload.file': 'Charger',
  'upload.file.title': 'Upload un nouveau file-set',
  'upload.file.name': 'Nom du fichier',
  'upload.file.type': 'Type de fichier',
  'upload.file.wait':
    "Veuillez patienter un moment. Les fichiers sont en cours de téléchargement d'analyse et de validation.",
  'upload.file.drag.and.drop':
    'Faites un glisser-déposer ou cliquez ici pour télécharger des fichiers',

  'upload.send': 'Envoyer',
  'upload.accept': 'Accepter tout et distribuer',
  'upload.reject': 'Refuser',
  'upload.reject.all': 'Refuser tout',
  'upload.download': 'Télécharger file-set',

  'upload.delete.modal.title': 'Delete confirmation',
  'upload.delete.modal.confirmation':
    'Êtes-vous sûr de vouloir supprimer <strong>{{{uploadName}}</strong> upload ?',
  'upload.version': 'Version du upload: ',

  'file.type.inspection.summary': 'Inspection summary',
  'file.type.action.summary': 'Observation summary',
  'file.type.report': 'Report',
  'file.type.unknown': 'Inconnu',

  'report.details.object.details.title': "Détails de l'objet",
  'report.details.comments.title': 'Commentaires',
  'lifting.object.details.equipment': 'EQUIPMENT ID',
  'lifting.object.details.site': 'SITE',
  'lifting.object.details.impactFacility': 'IMPACT FACILITY',
  'lifting.object.details.description': 'DESCRIPTION',
  'lifting.object.details.buildingDescriptionEn': 'DESCRIPTION OF BUILDING',
  'lifting.object.details.responsible': 'RESPONSIBLE',
  'lifting.object.details.status': 'STATUS',
  'lifting.object.details.commissionDate': 'COMMISSION DATE',
  'lifting.object.details.inspector': 'INSPECTOR',
  'lifting.object.details.equipmentClass': 'CLASS',
  'lifting.object.details.manufacturer': 'MANUFACTURER',
  'lifting.object.details.hseCode': 'HSE CODE',
  'lifting.object.details.category': 'CATEGORY',
  'lifting.object.details.model': 'MODEL',
  'lifting.object.details.building': 'BUILDING',
  'lifting.object.details.serialNumber': 'SERIAL NUMBER',

  'electrical.object.details.buildingNumber': 'BATIMENT',
  'electrical.object.details.department': 'DEPARTEMENT',
  'electrical.object.details.experiment': 'EXPERIENCE',
  'electrical.object.details.site': 'SITE',

  'error.uploading.fileset': 'Erreur de téléchargement de file-set',
  'success.uploading.fileset': 'File-set a été téléchargé avec succès',

  'upload.column.options': '',
  'uploadFilteredEntity_displayname': 'Uploads',
  'upload.column.name': 'Nom',
  'upload.column.inspection.type': "Type d'inspection d'import",
  'upload.column.version': 'Version',
  'upload.column.uploadDate': 'Date de téléchargement',
  'upload.column.company': 'Entreprise',
  'upload.column.status': 'Statut',
  'upload.column.uploadedBy': 'Téléchargé par',
  'upload.column.isValid': 'Valable',
  'upload.column.isSent': 'Envoyé',
  'upload.column.isAccepted': 'Accepté',
  'upload.column.validationMessage': 'Message de validation',

  'uploadFileFilteredEntity_displayname': 'Liste des fichiers',
  'upload.file.column.options': '',
  'upload.file.column.name': 'Nom',
  'upload.file.column.type': 'Type',
  'upload.file.column.uploadDate': 'Date de téléchargement',
  'upload.file.column.equipmentCode': "Code de l'équipement",
  'upload.file.column.building': 'Bâtiment',
  'upload.file.column.interventionDate': "Date d'intervention",
  'upload.file.column.executedBy': 'Exécuté par',
  'upload.file.column.company': 'Entreprise',
  'upload.file.column.conclusion': 'Conclusion',
  'upload.file.column.valid': 'Valable',
  'upload.file.column.validationMessage': 'Message de validation',
  'upload.file.column.status': 'Statut',
  'upload.file.column.sailor.inspection': 'Lien vers SAILOR',
  'upload.file.column.actionCount': 'Total des observations',
  'upload_status.value.validated': 'Validé',
  'upload_status.value.missing_action_summary': 'Absence de action summary',
  'upload_status.value.not_validated': 'Non validé',
  'upload_status.value.cancelled': 'Annulé',
  'upload_status.value.waiting_for_acceptance': "Attendre l'acceptation",
  'upload_status.value.in_progress': 'En cours',
  'upload_status.value.refused': 'Refusé',
  'upload_status.value.unknown': 'Inconnu',
  'upload_status.value.accepted_and_distributed': 'Accepté et distribué',
  'upload.rejection.modal.title': 'Motif du refus',
  'upload.rejection.modal.placeholder':
    'Veuillez préciser la raison pour laquelle vous refusez ce document.',
  'upload.comment.count': '{{commentsCount}} commentaire(s) pour ce rapport.',

  'liftingActionSummaryFilteredEntity_displayname': 'Liste des observations',
  'electricalActionSummaryFilteredEntity_displayname': 'Liste des observations',
  'action.summary.column.options': '',
  'action.summary.column.equipmentCode': "Code de l'équipement",
  'action.summary.column.description': 'Description',
  'action.summary.column.building': 'Bâtiment',
  'action.summary.column.floor': 'Étage',
  'action.summary.column.local': 'Locaux',
  'action.summary.column.interventionDate': "Date d'intervention",
  'action.summary.column.verificationReportNumber': 'Numéro du rapport de vérification',
  'action.summary.column.conclusion': 'Conclusion',
  'action.summary.column.observationNumber': "Numéro d'observation",
  'action.summary.column.observation': 'Observation',
  'action.summary.column.report': 'Rapport',
  'action.summary.column.valid': 'Valable',
  'action.summary.column.validationMessage': 'Message de validation',
  'action.summary.column.isOutside': 'Extérieur',
  'action.summary.column.equipment': 'Équipement',
  'action.summary.column.externalRegulatoryReference': 'Référence externe',
  'action.summary.column.cernRegulatoryReference': 'Règle du CERN',
  'action.summary.column.firstReportDate': 'Date du premier constat',
  'action.summary.column.criteria': 'Critère',
  'action.summary.column.urgency': 'Priorité',
  'action.summary.column.recommendation': 'Préconisation',
  'action.summary.column.assignee': 'Responsable',
  'action.summary.column.mitigation': 'L\'année d\'atténuation',
  'action.summary.column.report.number': 'Numéro de rapport',

  'lifting.inspection.summary.not.found':
    "Impossible de faire correspondre cette observation avec le dossier de Inspection summary. L'équipement {{equipmentCode}} n'est pas trouvé dans le fichier de Inspection summary.",
  'lifting.verification.report.number.not.consistent':
    "Le nom du rapport {{verificationNumber}} n'est pas cohérent avec le numéro du rapport de vérification.",
  'lifting.building.do.not.match.inspection.summary':
    'Le bâtiment {{building}} ne correspond pas au bâtiment {{inspectionSummaryBuilding}} dans le Inspection summary',
  'lifting.building.not.found': 'Le bâtiment {{building}} est introuvable dans la base de données.',
  'lifting.equipment.class.not.found':
    "Impossible d'obtenir de classe d'équipement InforEAM pour déterminer le thème d'observation.",
  'lifting.equipment.not.found':
    "L'équipement {{equipmentCode}} n'existe pas dans la base de données MTF/InforEAM",
  'lifting.theme.not.found': "Le thème {{theme}} n'est pas conforme au catalogue SAILOR.",
  'lifting.observation.number.sequence.error':
    "Le champ du numéro d'observation doit être {{nextSequenceNumber}}.",
  'lifting.conclusion.not.found':
    "La conclusion de Action Summary n'est pas conforme au catalogue SAILOR.",
  'lifting.conclusion.is.higher.than.inspection':
    "La priorité de la conclusion du rapport d'inspection doit être égale à la priorité la plus élevée parmi les conclusions de l'observation.",
  'lifting.inspection.conclusion.not.found':
    "La conclusion de Inspection Summary n'est pas conforme au catalogue SAILOR.",

  'electrical.criteria.not.fond': "Le critère {{criteria}} n'est pas conforme au catalogue SAILOR",
  'electrical.law.articles.are.empty':
    'Au moins un des champs suivants ne doit pas être vide : {{fieldList}}',
  'electrical.inspection.summary.not.found':
    "Le bâtiment {{acronym}} n'a pas été trouvé dans le fichier Inspection summary.",
  'electrical.executed.by.not.found':
    "Le contractant qui a exécuté l'inspection {{executedBy}} n'existe pas dans la base de données.",
  'electrical.executed.by.ambiguous':
    "Le nom du contractant qui a exécuté l'inspection {{executedBy}} fait référence à plusieurs personnes",
  'electrical.location.not.found':
    "Le local {{locationName}} n'existe pas dans la base de données officielle des locaux du CERN.",
  'electrical.location.not.found.or.not.uploaded':
    "Vérifiez si vous avez chargé le rapport PDF pour le local {{locationName}}, sinon il n''existe pas dans la base de données officielle des sites du CERN.",
  'electrical.urgency.not.allowed':
    "L'urgence {{urgency}} n'est pas autorisée. La valeur doit être 1 ou 2 ou 3",
  'electrical.not.out.of.building':
    "L'emplacement précis (bâtiment, étage, pièce) doit être spécifié ou l'extérieur du bâtiment doit être considéré comme vrai.",
  'electrical.no.report.for.acronym': "Le bâtiment {{acronyme}} n'est mentionné dans aucun rapport",
  'electrical.assignee.not.found': "Le responsable {{assignee}} n'existe pas dans la base de données",
  'electrical.assignee.ambiguous': 'Nom du responsable ambigu: {{assignee}} fait référence à plusieurs personnes',
  'electrical.mitigation.year.error': "L'année d'atténuation {{mitigation}} ne peut pas être dans le passé",

  'common.duplicate.record.found': 'Duplication {{columnLabel}} de la valeur {{value}}',
  'common.cell.dont.match.expected.value':
    'La valeur dans excel sur la ligne :{{row}} cell :{{column}} ne correspond pas à la valeur attendue :{{expectedValue}}',
  'common.empty.rows':
    'Il y a quelques lignes vides dans le fichier. Vérifiez par exemple le numéro de ligne :{{emptyRows}}.',
  'common.is.not.number': "{{columnLabel}} {{number}} n'est pas un nombre",
  'common.inspection.type.not.found': "Le type d'inspection n'est pas correct",
  'common.field.is.empty': '{{columnLabel}} est vide',
  'common.intervention.date.do.not.match.inspection.summary':
    "La date d'intervention ne correspond pas à la date d'intervention figurant dans le Inspection summary",
  'common.date.in.past': '{{columnLabel}} est supérieure à {{pastMonthLimit}} mois dans le passé',
  'common.date.in.future': '{{columnLabel}} est dans le futur',
  'common.error.parsing.date':
    "{{columnLabel}} n'est pas formaté comme une date. Les formats autorisés sont :{{allowedDateFormats}}",
  'common.verification.report.number.not.consistent':
    "Le nom du rapport {{reportName}} n'est pas cohérent avec le numéro du rapport de vérification {{verificationNumber}}.",
  'common.verification.report.number.sent.for.validation':
    "L'observation avec le numéro de rapport de vérification {{verificationNumber}} est déjà en cours de validation.",
  'common.error.observation.number.sequence':
    "Le champ du numéro d'observation doit être {{nextSequenceNumber}}.",
  'common.report.was.not.uploaded': "Le rapport {{fileName}} n'a pas été téléchargé.",
  'common.inspector.not.found': "L'inspecteur {{inspector}} n'existe pas dans la base de données.",
  'common.inspector.ambiguous':
    "Nom d'inspecteur ambigu :{{inspector}} fait référence à plusieurs personnes.",
  'common.company.not.found': 'Société {{company}} non trouvée',
  'common.company.doesnt.match.current.user':
    "Le nom de la société ne correspond pas à celui de l'entrepreneur qui a téléchargé ce document.",
  'common.summary.file.has.errors':
    '{{fileType}} a des erreurs. Veuillez ouvrir pour plus de détails',

  'error.upload.not.found': 'Le téléchargement {{uploadId}} est introuvable !',
  'success.upload.status.change': 'Le statut a été mis à jour avec succès à «{{uploadStatus}}»',
  'error.upload.status.change': 'Erreur de mise à jour du statut à «{{uploadStatus}}»!',
  'error.downloading.file': 'Erreur de téléchargement du fichier!',
  'success.upload.delete': 'Suppression réussie du téléchargement «{{uploadName}}»',
  'error.upload.delete': "Erreur de suppression d'un téléchargement «{{uploadName}}»!",
  'error.object.details.fetch': "Erreur dans la récupération des détails de l'objet!",
  'error.fetching.comments': 'Erreur dans la récupération des commentaires!',
  'error.saving.comment': "Erreur d'enregistrement du commentaire!",
  'success.saving.comment': 'Le commentaire a été enregistré',
  'error.inspection.details.fetch':
    "Erreur dans la récupération des détails de l'inspection {{inspectionId}}»!",

  '401.error.title': '403 Forbidden or 401 Unauthorized',
  '401.error.description':
    'Vous êtes interdit ou non autorisé à visualiser ce contenu. Afin de demander une autorisation, veuillez contacter le support logiciel.',

  'electrical.column.num.infrastructure': "Numéro d'infrastructure",
  'electrical.column.verification.number': 'Numéro du rapport de verification contrat',
  'electrical.column.intervention.date': "Date d'intervention",
  'electrical.column.observation.number': "Numéro de l'observation",
  'electrical.column.floor': 'Étage',
  'electrical.column.local': 'Local',
  'electrical.column.outside': 'Extérieur',
  'electrical.column.equipment': 'Équipement',
  'electrical.column.equipment.number': 'Num Équipement',
  'electrical.column.observation': 'Observation',
  'electrical.column.recommendation': 'Préconisation',
  'electrical.column.regulatory.ref': 'Référence Réglementaire',
  'electrical.column.cern.rule': 'Règle CERN',
  'electrical.column.date.first.finding': 'Date du premier constat',
  'electrical.column.criteria': 'Critère',
  'electrical.column.priority': 'Priorité',
  'electrical.column.acronym': 'Sigle',
  'electrical.column.file': 'Fichier',
  'electrical.column.inspection.type': "Type d'inspection",
  'electrical.column.executed.by': 'Exécutée par',
  'electrical.column.company': 'Compagnie',
  'electrical.column.inspector': 'Inspecteur CERN',
  'electrical.column.comment': 'Commentaire',
  'electrical.column.disposition': 'Disposition déterminante pour la sécurité',
  'electrical.column.conclusion': 'Conclusion',
  'electrical.column.mitigation': 'Mitigation',

  'lifting.column.equipment.code': "Numéro d'equipement",
  'lifting.column.description': 'Description',
  'lifting.column.building': 'Bâtiment',
  'lifting.column.floor': 'Étage',
  'lifting.column.local': 'Local',
  'lifting.column.intervention.date': "Date d'intervention",
  'lifting.column.verification.number': 'Numéro du rapport de vérification',
  'lifting.column.conclusion': 'Conclusion',
  'lifting.column.observation.number': "Numéro de l'observation",
  'lifting.column.theme': 'Theme',
  'lifting.column.observation': 'Observation',
  'lifting.column.file': 'Fichier',
  'lifting.column.capacity': 'Capacité',
  'lifting.column.inspection.type': "Type d'inspection",
  'lifting.column.executed.by': 'Exécutée par',
  'lifting.column.company': 'Compagnie',
  'lifting.column.inspector': 'Inspecteur CERN',
  'lifting.column.disposition': 'Disposition déterminante pour la sécurité',
  'lifting.column.recommendation': 'Recommandation',
  'lifting.column.additional.conclusion': 'Conclusion additionnelle',
};

export default TRANSLATIONS_FR;
